import Vue from 'vue'
import App from './App.vue'
import {store} from "./store/store"
import {BCard, BContainer, BCardText, BCardImg, BCardBody} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.component('b-card', BCard)
Vue.component('b-container', BContainer)
Vue.component('b-card-text', BCardText)
Vue.component('b-card-img', BCardImg)
Vue.component('b-card-body', BCardBody)

Vue.config.productionTip = false


new Vue({
  store: store,
  render: h => h(App),
}).$mount('#app')
